import React from 'react';
import {
    Form,
    FormControl
} from 'react-bootstrap'
const ClubRegistrationLanguageComponent = ({ handleLanguageChange,composingLabel }) => {

    return (
        <Form name='registrationLanguageForm' className='registrationLanguageForm'>
            <FormControl
                className='registrationLanguageField'
                componentClass="select"
                name='registrationLanguage'
                defaultValue={'EN'}
                onChange={handleLanguageChange} >
                <option value={'EN'}>{composingLabel('sportOauthLabel.English','English')} </option>
                <option value={'FR'}>{composingLabel('sportOauthLabel.French','Fran�ais')}</option>
                {/* <option value={'DE'}>Deutsch</option> */}

            </FormControl>

        </Form>
    )
}

export default ClubRegistrationLanguageComponent;


// WEBPACK FOOTER //
// ./src/main/resources/js/components/RegistrationFormComponents/ClubRegistrationLanguageComponent.js